import { PaneArea } from '../../../types/shared'
import Position, { IPositionAttrs } from '../../canvas/position'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IPositionAttrs
type PartialAttrs = Partial<Attrs>

class PositionCreator extends Position<Attrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    const width = this.model.scale.x.width(35)
    const height = this.model.scale.y.height(35)
    this.attrs.x1 = startArea.x - width
    this.attrs.x2 = startArea.x + width
    this.attrs.stopY = startArea.y + height
    this.attrs.centerY = startArea.y
    this.attrs.targetY = startArea.y - height

    setTimeout(() => {
      this.replaceMyself(Position.fromObject<Position>(this.attrs, this.model))
      toolsCallback()
    })

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }
}

export default PositionCreator
